import React, { useRef, useEffect, useState }   from 'react';
import { Modal, Button, Form }                  from 'react-bootstrap';
import { useDispatch, useSelector }             from 'react-redux';

import { ICON_SAVE, ICON_CANCEL }               from '../../extras/icons';
import { ErrorMessage }                         from '../../extras/toastMessages';
import { Formik }                               from 'formik';
import { MSG_ERROR_SERVER }                     from '../../../constants/messages';
import { saveAudienceMotivesAction }            from '../../../actions/audienceMotivesActions';
import { updateAudienceMotivesAction }          from '../../../actions/audienceMotivesActions';

import ButtonSpinner                            from '../../layout/ButtonSpinner';
import clienteAxios                             from '../../../config/axios';

import * as yup                                 from 'yup';




const AudienceMotiveForm = props => {



    //---------------------------------------------------------------------------------------------
    // DECLARACIONES ------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------------

    // Tomo los props
    const { show, handleClose } = props;

    // Genero los refs
    const refDescription = useRef();

    // Datos iniciales
    const initialData = {
        descripcion: '',
        grupo: ''
    }

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Traigo el store de persona tipos
    const audienceMotivesLoading = useSelector( state => state.audienceMotives.loadingSave );
    const audienceMotiveSelected = useSelector( state => state.audienceMotives.audienceMotiveSelected );
    const isEdit = useSelector( state => state.audienceMotives.isEdit );

    // Inicializo el state local
    const [ audienceMotive, setAudienceMotive ] = useState(initialData);
    const [groups, setGroups] = useState([]);



    //---------------------------------------------------------------------------------------------
    // FUNCIONES ----------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------------

    // Modifico según el cambio
    useEffect(() => {
        //Cargo los Grupos
        loadParameters();
        //Me fijo si es edición
        if(isEdit && audienceMotiveSelected)
        {   setAudienceMotive({
                ...audienceMotiveSelected,
                grupo: audienceMotiveSelected.grupoId
            });
        }
        else
        {   setAudienceMotive(initialData);
        }
        //eslint-disable-next-line
    }, [isEdit, audienceMotiveSelected, show])

    // Manejo de cambios
    const handleChange = e => {
        setAudienceMotive({
            ...audienceMotive,
            [e.target.name]: e.target.value
        })
    }

    // Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setAudienceMotive(initialData);
        //Cierro
        handleClose();
    }

    // Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    
    // Manejo el guardado
    const handleSave = values => {
        //Inicializo los datos
        let data = {
            ...audienceMotive,
            activo: 1
        }
        //Agrego los nuevos valores
        data = {
            ...data,
            ...values
        }
        //Verifico si es edición o alta
        if(audienceMotive.id)
        {   //Es edición
            dispatch( updateAudienceMotivesAction(data, handleCloseForm) );
        }
        else
        {   //Es creación
            dispatch( saveAudienceMotivesAction(data, handleCloseForm) );
        }
    }


    // Cargo los Grupos
    const loadParameters = async () => {
        try
        {   //Hago la consulta
            const response = await clienteAxios.get(`/motivo/grupos`);
            //Obtengo los datos
            const result = response.data;
            //Los guardo
            setGroups(result);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    

    

    // Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required(),
        grupo: yup.number().required()
    });
    


    //---------------------------------------------------------------------------------------------
    // RENDERIZO ----------------------------------------------------------------------------------
    //---------------------------------------------------------------------------------------------

    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Audiencia Motivo&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema = { validationSchema }
                initialValues = {{ ...audienceMotive }}
                onSubmit = { values=>handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        autoFocus 
                                        className = "form-control" 
                                        disabled = { audienceMotivesLoading }
                                        id = "descripcion"
                                        isInvalid = { !!errors.descripcion }
                                        name = "descripcion" 
                                        onChange = { handleChange }
                                        ref = { refDescription }
                                        type = "text" 
                                        value = { values.descripcion }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="grupo">Grupo</label>
                                    <Form.Control
                                        as = "select"
                                        className = "form-control"  
                                        disabled = { audienceMotivesLoading }
                                        id = "grupo"
                                        isInvalid = {!!errors.grupo }
                                        name = "grupo" 
                                        onChange = { handleChange }
                                        type = "text" 
                                        value = { values.grupo }
                                    >
                                        <option value="">Seleccione el Grupo</option>
                                        {   groups.map( group=>(
                                                <option value={group.id} key={`amg${group.id}`}>
                                                    { group.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.grupo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {   audienceMotivesLoading 
                                    ?
                                        <ButtonSpinner />
                                    :
                                        <Button variant="success" type="submit" disabled={ audienceMotivesLoading }>
                                            <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                        </Button>
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ audienceMotivesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default AudienceMotiveForm;
